import * as R from 'ramda';

const coverageHistory = (state: any) => R.pathOr([], ['mycoverage', 'extendCoverageHistory'], state)
const careHistory = (state: any) => R.pathOr([], ['mycoverage', 'careHistory'], state);
const nonCoverageClaims = (state: any) => R.pathOr([], ['mycoverage', 'nonCoverageClaimsHistory'], state);
const coverageClaims = (state: any) => R.pathOr([], ['mycoverage', 'coverageClaimsHistory'], state);
const careClaims = (state: any) => R.pathOr([], ['mycoverage', 'warrantyCareClaimHistory'], state);
const keylifecyclechartData = (state: any) => R.pathOr([], ['mycoverage', 'chartDataproviders'], state);

const selectors = {
    coverageHistory,
    careHistory,
    nonCoverageClaims,
    coverageClaims,
    careClaims,
    keylifecyclechartData
};

export default selectors;